

import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import NotificationRule from "@/types/sv-data/notification-rule/NotificationRule";
import NotificationRuleActions from "@/components/notification-templates/NotificationRuleActions.vue";
import NotificationRuleConditions from "@/components/notification-templates/NotificationRuleConditions.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { cloneDeep, isEqual } from "lodash";
import NotificationRuleAction from "@/types/sv-data/notification-rule/NotificationRuleAction";
import NotificationRuleCondition from "@/types/sv-data/notification-rule/NotificationRuleCondition";
import { UserPermissions } from "@/store/types";
import { Getter } from "vuex-class";

@Component({
    components: {
        "notification-rule-conditions": NotificationRuleConditions,
        "notification-rule-actions": NotificationRuleActions,
		"scrollbar": VuePerfectScrollbar     
	}
})
export default class NotificationRuleSetupModal extends Vue {

	@Prop({ required: true, default: false})
	private showModal: boolean;

    @Prop({type: Object, required: true})
    private rule: NotificationRule;
    
	@Getter("getPermissions") private permissions: UserPermissions;

    private selectedRule: NotificationRule | null = null;
    private actionsAreValid: boolean = false;
    private conditionsAreValid: boolean = false;
    private submitted: boolean = false;

    private mounted(): void {
        this.selectedRule = cloneDeep(this.rule);
    }
    
    private get ruleIsInvalid(): boolean {
        const hasChanged = !isEqual(this.rule, this.selectedRule);
        return !this.selectedRule?.title || !this.actionsAreValid || !this.conditionsAreValid || (this.isEdit && !hasChanged);
    }
    
	private get isReadOnly(): boolean {
		return this.permissions.canViewNotificationRules && !this.permissions.canEditNotificationRules;
	}

    private get isEdit(): boolean {
        return !!this.selectedRule.notificationRuleId;
    }

    @Watch("rule")
    private onRuleChanged(): void {
        this.selectedRule = cloneDeep(this.rule);
        this.submitted = false;
    }    
    
	@Emit("closeSetupModal")
	private closeSetupModal(): void {
        return;	
	}

	private async saveCurrentRule(): Promise<void> {
        this.submitted = true;
        if (!this.selectedRule || !this.selectedRule.title || !this.selectedRule.actions || !this.selectedRule.conditions) {
            return;
        }

        this.selectedRule.actions.forEach((action: NotificationRuleAction) => {
            if (typeof action.notificationRuleActionId == "string"){
                action.notificationRuleActionId = null;
            }
        });

        this.selectedRule.conditions.forEach((condition: NotificationRuleCondition) => {
            if (typeof condition.notificationRuleConditionId == "string") {
                condition.notificationRuleConditionId = null;
            }
        });

        if (!this.isEdit) {
            this.$emit("addRule", this.selectedRule);
        } else {
            this.$emit("updateRule", this.selectedRule);
        }
	}

    private onUpdateActions(actions: NotificationRuleAction[]): void {
        this.selectedRule.actions = cloneDeep(actions);
    }

    private onUpdateConditions(conditions: NotificationRuleCondition[]): void {
        this.selectedRule.conditions = cloneDeep(conditions);
    }

    private onConditionsValidationUpdated(valid: boolean): void {
        this.conditionsAreValid = valid;
    }

    private onActionsValidationUpdated(valid: boolean): void {
        this.actionsAreValid = valid;
    }
}
